import React from 'react';
import Header from './Header';
import Footer from './Footer';
import ScrollBackground from '../shared/ScrollBackground';

const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col relative">
      <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none">
        <div className="absolute inset-0 bg-[hsl(220,25%,14%)]" />
        <div className="absolute inset-0 sgpt-grid-animated" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,rgba(15,20,30,0.4)_100%)]" />
      </div>
      <ScrollBackground />
      <Header />
      <main className="flex-1 relative">
        {children}
      </main>
      <Footer />
    </div>
  );
};

export default Layout;
